import { GridState } from '@mui/x-data-grid'
import { DATA_GRID_STATE_KEY as SHIPPING_AMAZON_ORDERS_STATE_KEY } from 'screens/AmazonOrders/constants'
import { DATA_GRID_STATE_KEY as BILLING_DASHBOARD_CHARGES_STATE_KEY } from 'screens/BillingDashboard/Charges/constants'
import { DATA_GRID_STATE_KEY as BILLING_DASHBOARD_INVOICES_STATE_KEY } from 'screens/BillingDashboard/Invoices/constants'
import { DATA_GRID_STATE_KEY as BILLING_DASHBOARD_SUBSCRIPTIONS_STATE_KEY } from 'screens/BillingDashboard/Subscriptions/constants'
import { DATA_GRID_STATE_KEY as COACHES_BILLING_DETAILS_STATE_KEY } from 'screens/CoachesBilling/InvoiceDetails/ItemsGrid/constants'
import { DATA_GRID_STATE_KEY as USER_APPOINTMENTS_STATE_KEY } from 'screens/UserAppointments/constants/constants'
import { PER_PAGE_OPTIONS } from './constants'

export const DEFAULT_STATE = {
  pagination: { pageSize: PER_PAGE_OPTIONS[2] }
} as GridState

const BILLING_DASHBOARD_DEFAULT_STATE = {
  pagination: { pageSize: PER_PAGE_OPTIONS[0] }
} as GridState

const COACHES_BILLING_DETAILS_DEFAULT_STATE = {
  sorting: {
    sortModel: [
      {
        field: 'date',
        sort: 'asc'
      }
    ]
  }
} as GridState

const SHIPPING_AMAZON_ORDERS_DEFAULT_STATE = {
  sorting: {
    sortModel: [{ field: 'purchasedAt', sort: 'desc' }]
  }
} as GridState

const USER_APPOINTMENTS_DEFAULT_STATE = {
  sorting: {
    sortModel: [{ field: 'meetingAt', sort: 'desc' }]
  }
} as GridState

const DEFAULT_STATES = {
  [BILLING_DASHBOARD_SUBSCRIPTIONS_STATE_KEY]: BILLING_DASHBOARD_DEFAULT_STATE,
  [BILLING_DASHBOARD_INVOICES_STATE_KEY]: BILLING_DASHBOARD_DEFAULT_STATE,
  [BILLING_DASHBOARD_CHARGES_STATE_KEY]: BILLING_DASHBOARD_DEFAULT_STATE,
  [COACHES_BILLING_DETAILS_STATE_KEY]: COACHES_BILLING_DETAILS_DEFAULT_STATE,
  [SHIPPING_AMAZON_ORDERS_STATE_KEY]: SHIPPING_AMAZON_ORDERS_DEFAULT_STATE,
  [USER_APPOINTMENTS_STATE_KEY]: USER_APPOINTMENTS_DEFAULT_STATE
}

export const defaultState = (stateKey: string) =>
  DEFAULT_STATES[stateKey as keyof typeof DEFAULT_STATES] || DEFAULT_STATE
